export default "__VITE_ASSET__C53CWRss__"